import { useTranslation } from 'react-i18next';

function Sponsor() {
  const { t } = useTranslation();
  const sponsorTypes = [
    {
      type: 'gold',
      image: '/img/sponsor/gold_sponsor1.webp',
      titleKey: 'sponsorPage.gold',
      price: 'sponsorPage.gold_price',
      descriptionKey: 'sponsorPage.gold_description',
    },
    {
      type: 'silver',
      image: '/img/sponsor/silver_sponsor.webp',
      titleKey: 'sponsorPage.silver',
      price: 'sponsorPage.silver_price',
      descriptionKey: 'sponsorPage.silver_description',
    },
    {
      type: 'bronze',
      image: '/img/sponsor/bronze_sponsor.webp',
      titleKey: 'sponsorPage.bronze',
      price: 'sponsorPage.bronze_price',
      descriptionKey: 'sponsorPage.bronze_description',
    },
  ];

  return (
    <div className="container">
      <style>
        {`
          .pf-sponsor-card {
            transition: all 0.3s ease;
            cursor: default;
            padding: 20px;
            border-radius: 20px;
          }
          .pf-sponsor-card:hover {
            background-color: rgba(255,255,255,0.7);
            box-shadow: 0 10px 40px rgba(0,0,0,0.05);
          }
          .pf-sponsor-img {
            width: 250px;
            height: 250px;
            object-fit: cover;
            border: 5px solid #fff;
            box-shadow: 0 8px 25px rgba(0,0,0,0.1);
            transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.4s ease;
          }
          .pf-sponsor-card:hover .pf-sponsor-img {
            transform: scale(1.05);
            box-shadow: 0 12px 35px rgba(0,0,0,0.15);
          }
        `}
      </style>
      <div className="col-lg-12">
        <h3>{t('sponsorPage.title')}</h3>
        <p>{t('sponsorPage.intro')}</p>
        <h5>{t('sponsorPage.sponsor_types')}</h5>
        <div className="row mt-4">
          {sponsorTypes.map(sponsor => (
            <div key={sponsor.type} className="col-lg-4 col-md-6 mb-4">
              <div className="d-flex flex-column align-items-center text-center pf-sponsor-card">
                <img
                  src={sponsor.image}
                  className="rounded-circle pf-sponsor-img"
                  alt={t(`sponsorPage.${sponsor.type}`)}
                />
                <h4 className="mt-4" style={{ fontWeight: '700', color: '#333' }}>{t(sponsor.titleKey)}</h4>
                <h5 className="mt-1" style={{ color: '#fca311', fontWeight: 'bold' }}>{t(sponsor.price)}</h5>
                <p className="mt-2 text-muted" style={{ lineHeight: '1.6' }}>{t(sponsor.descriptionKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Sponsor;
